import { createContext, ReactNode, useContext, useEffect, useState } from 'react'

interface ClientPreviewContextValue {
  /** true quand un admin prévisualise la vue client : le layout affiche le bandeau client au lieu de la sidebar */
  clientPreview: boolean
  setClientPreview: (value: boolean) => void
}

const ClientPreviewContext = createContext<ClientPreviewContextValue>({
  clientPreview: false,
  setClientPreview: () => {},
})

export function ClientPreviewProvider({ children }: { children: ReactNode }) {
  const [clientPreview, setClientPreview] = useState(false)
  return (
    <ClientPreviewContext.Provider value={{ clientPreview, setClientPreview }}>
      {children}
    </ClientPreviewContext.Provider>
  )
}

export function useClientPreview() {
  return useContext(ClientPreviewContext)
}

/** Active l'aperçu client du layout tant que `active` est vrai et que la page est affichée. */
export function useClientPreviewLayout(active: boolean) {
  const { setClientPreview } = useClientPreview()
  useEffect(() => {
    setClientPreview(active)
    return () => setClientPreview(false)
  }, [active, setClientPreview])
}
